import React, {useContext, useEffect, useState} from 'react';
import Select from "react-select";
import {Card, CardContent, Checkbox, FormControlLabel, Grid, TextField, Tooltip} from '@mui/material';
import {Controller} from 'react-hook-form';
import {Info} from "react-feather";
import {
    CommodityTypeService,
    ConsigneeService,
    CountryService,
    IncoTermService,
    PartnerSiteService,
    ShipmentModeService
} from "../../services";
import {ShippingInstructionContext} from "./shipping-instruction-context";
import ValidationError from "../shared/ValidationError";
import CountryOverride from "./country-override";

const GrantInfo = (props) => {
    const {control} = props;

    const {data, setData, methods} = useContext(ShippingInstructionContext);
    const [isChecked, setIsChecked] = useState(false);
    const [disable, setDisable] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [consigneeList, setConsigneeList] = useState([]);
    const [selectedConsignee, setSelectedConsignee] = useState({});
    const [selectedPartnerSites, setSelectedPartnerSites] = useState({});
    const [shipmentModeList, setShipmentModeList] = useState([]);
    const [partnerSiteList, setPartnerSiteList] = useState([]);
    // eslint-disable-next-line
    const [commodityTypeList, setCommodityTypeList] = useState([]);
    const [clientIncoTermsList, setClientIncoTermsList] = useState([]);
    const [vendorIncoTermsList, setVendorIncoTermsList] = useState([]);
    const {errors, setValue} = methods;

    const onCountryChanged = (value) => {
        let newData = {...data};
        const selectedCountry = countryList.find(c => c.id === value);
        if (selectedCountry !== undefined) {
            newData.countryId = selectedCountry.id;
            newData.countryName = selectedCountry.countryName;
        }
        if (value !== data.countryId) {
            newData = {
                ...newData,
                consigneeId: undefined,
                consigneeName: '',
                partnerSiteId: undefined,
                partnerSiteName: '',
                consignee: {}, partnerSite: {}
            };
            setValue('consigneeId', undefined);
            setValue('partnerSiteId', undefined);
        }

        setData(newData);
        // populate cascaded dropdowns here.
        ConsigneeService.getByCountry(value)
            .then((response) => {
                setConsigneeList(response.data)
                if (data.consigneeId !== undefined) {
                    setSelectedConsignee(response.data.find((c) => c.id === data.consigneeId))
                }
            });

        PartnerSiteService.getByCountry(value)
            .then((response) => {
                setPartnerSiteList(response.data)
                if(data.partnerSiteId !== undefined) {
                    setSelectedPartnerSites(response.data.find((c) => c.id === data.partnerSiteId))
                }
            });

    }

    const onParnerSiteChange = (value) => {
        const selectedPartnerSites = partnerSiteList.find(c => c.id === value.value);
        if (selectedPartnerSites !== undefined) {
            setData({...data, partnerSiteId: value, partnerName: selectedPartnerSites.partnerName});
            setSelectedPartnerSites(selectedPartnerSites);
        }
    }

    const onConsigneeChange = (value) => {
        const selectedConsignee = consigneeList.find(c => c.id === value.value);
        if (selectedConsignee !== undefined) {
            setData({...data, consigneeId: value, consigneeName: selectedConsignee.consigneeName});
            setSelectedConsignee(selectedConsignee);
        }
    }

    const onCommodityTypeChanged = (c) => {
        setData({
            ...data,
            commodityTypes: c.map(ct => ({commodityTypeId: ct.value, commodityTypeName: ct.label}))
        });
    }

    useEffect(() => {
        CountryService.getAll()
            .then((response) => setCountryList(response.data));

        CommodityTypeService.getAll()
            .then((response) => setCommodityTypeList(response.data.map(ct => {
                return {label: ct.name, value: ct.id}
            })));

        ShipmentModeService.getAll()
            .then((response) => setShipmentModeList(response.data));

        IncoTermService.getAll()
            .then((response) => {
                setClientIncoTermsList(response.data.filter(t => (t.forClient === true)));
                setVendorIncoTermsList(response.data.filter(t => (t.forVendor === true)));
            });

        if (data.countryId) {
            onCountryChanged(data.countryId);
        }
        if(data.vendorIncoTerms[0].incoTermName !== 'EXW'
             && data.vendorIncoTerms[0].incoTermName !== 'FCA'
             && data.vendorIncoTerms[0].incoTermName !== 'EXW/FCA' ){
            setDisable(true)
        }else{
            setDisable(false)
        }

        if(data.excludeDeliveryAddress === true){
            setIsChecked(true)
        }
        // eslint-disable-next-line
    }, [])

        const handleCheckboxChange = (e) => {
          setIsChecked(e.target.checked);
        };

         const handleVendorIncoTermChange = (e) => {         

          if (e !== 'EXW' && e !== 'FCA' && e !== 'EXW/FCA') {
            setIsChecked(false);
            setDisable(true);
            }else{
                setDisable(false);
            }
        };

        useEffect(() => {            
         setData({...data, excludeDeliveryAddress: isChecked})
        }, [isChecked])

       // const isCheckboxDisabled = selectedValue === 'DisableCheckbox';
    return (
        <div>
            <Card>
                <CardContent>
                    <h3>Grant Information</h3>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <div>
                                <Controller
                                    name="grantCode"
                                    control={control}
                                    rules={{required: 'Grant Code is required.'}}
                                    as={TextField}
                                    fullWidth
                                    label="Grant Code"
                                    color="primary"
                                    variant="outlined"
                                    defaultValue={data.grantCode}
                                    render={({onChange, value}) => <TextField
                                        autoComplete="grantCode"
                                        value={value}
                                    />}
                                />
                                <ValidationError error={errors.grantCode}/>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                        </Grid>
                        <Grid item xs={6}>

                            <FormControlLabel label="Country"
                                              htmlFor="countryId"
                                              className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                              labelPlacement="top"
                                              control={<></>}/>
                            <Controller
                                name="countryId"
                                control={control}
                                rules={{required: 'Country is required.'}}
                                label="Country"
                                defaultValue={data.countryId}
                                color="primary"
                                variant="outlined"
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (<Select
                                    value={countryList.filter(s => s.id === value).map(v => {
                                        return {value: v.id, label: v.countryName}
                                    })}
                                    onChange={value => {
                                        onChange(value.value);
                                        onCountryChanged(value.value)
                                    }}
                                    options={countryList.map(p => ({value: p.id, label: p.countryName}))}
                                />)}
                            />
                            {errors.countryId &&
                                <ValidationError error={errors.countryId}/>
                            }

                        </Grid>
                        <Grid item xs={6}>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel label="Consignee"
                                              htmlFor="consigneeId"
                                              className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                              labelPlacement="top"
                                              control={<></>}/>
                            <Controller
                                control={control}
                                name="consigneeId"
                                rules={{required: 'Consignee is required.'}}
                                defaultValue={data.consigneeId}
                                render={({value, name, onChange}) =>
                                    <Select
                                        value={{value: data.consigneeId, label: data.consigneeName}}
                                        onChange={value => {
                                            onChange(value.value);
                                            onConsigneeChange(value)
                                        }}
                                        options={consigneeList.map(p => ({value: p.id, label: p.consigneeName}))}
                                    />
                                }
                            />
                            {errors.consigneeId &&
                                <ValidationError error={errors.consigneeId}/>
                            }
                        </Grid>
                        <Grid item xs={1} container direction="row" alignItems="flex-end">
                            <Tooltip title={selectedConsignee && selectedConsignee.address}>
                                <Info fontSize="small"/>
                            </Tooltip>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControlLabel label="Partner Sites (Ship-to)"
                                              htmlFor="partnerSiteId"
                                              className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                              labelPlacement="top"
                                              control={<></>}/>
                            <Controller
                                control={control}
                                name="partnerSiteId"
                                rules={{required: 'Partner Site is required.'}}
                                defaultValue={data.partnerSiteId}
                                render={({value, onChange}) =>
                                    <Select
                                        value={partnerSiteList.filter(s => s.id === value).map(v => {
                                            return {value: v.id, label: v.partnerName}
                                        })}
                                        onChange={value => {
                                            onChange(value.value)
                                            onParnerSiteChange(value)
                                        }}
                                        options={partnerSiteList.map(p => ({value: p.id, label: p.partnerName}))}
                                    />
                                }
                            />
                            {errors.partnerSiteId &&
                                <ValidationError error={errors.partnerSiteId}/>
                            }
                        </Grid>
                        <Grid item xs={1} container direction="row" alignItems="flex-end">
                            <Tooltip title={selectedPartnerSites && selectedPartnerSites.address}>
                                <Info fontSize="small"/>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={5}>
                        </Grid>
                        <Grid item xs={1.9}>
                            <FormControlLabel label="Shipment Mode"
                                              htmlFor="shipmentModeId"
                                              className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                              labelPlacement="top"
                                              control={<></>}/>
                            <Controller
                                control={control}
                                rules={{required: 'Shipment mode is required.'}}
                                name="shipmentModeId"
                                defaultValue={data.shipmentModeId}
                                render={({value, onChange}) =>
                                    <Select
                                        value={shipmentModeList.filter(s => s.id === value).map(v => {
                                            return {value: v.id, label: v.modeCode}
                                        })}
                                        onChange={value => {
                                            onChange(value.value)
                                        }}
                                        options={shipmentModeList.map(p => ({value: p.id, label: p.modeCode}))}
                                    />
                                }
                            />
                            {errors.shipmentModeId &&
                                <ValidationError error={errors.shipmentModeId}/>
                            }
                        </Grid>

                        <Grid item xs={1.9}>
                            <FormControlLabel label="Vendor Incoterm"
                                              className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                              labelPlacement="top"
                                              control={<></>}/>
                            <Controller
                                control={control}
                                name="vendorIncoTerms[0].incoTermId"
                                rules={{required: 'Vendor Incoterm is required.'}}
                                defaultValue={data.vendorIncoTerms[0].incoTermId}
                                render={({value, onChange}) =>
                                    <Select
                                        value={vendorIncoTermsList.filter(s => s.id === value).map(v => {
                                            return {value: v.id, label: v.termCode}
                                        })}
                                        onChange={value => {
                                            onChange(value.value)
                                            handleVendorIncoTermChange(value.label)
                                        }}
                                        options={vendorIncoTermsList.map(p => ({value: p.id, label: p.termCode}))}
                                    />
                                }
                            />
                            {errors.vendorIncoTerms &&
                                <ValidationError error={errors.vendorIncoTerms[0].incoTermId}/>
                            }
                        </Grid>
                        <Grid item xs={1.9}>
                            <FormControlLabel label="Client Incoterm"
                                              className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                              labelPlacement="top"
                                              control={<></>}/>
                            <Controller
                                control={control}
                                name="clientIncoTerms[0].incoTermId"
                                rules={{required: 'Client Incoterm is required.'}}
                                defaultValue={data.clientIncoTerms[0].incoTermId}
                                render={({value, onChange}) =>
                                    <Select
                                        value={clientIncoTermsList.filter(s => s.id === value).map(v => {
                                            return {value: v.id, label: v.termCode}
                                        })}
                                        onChange={value => {
                                            onChange(value.value)
                                        }}
                                        options={clientIncoTermsList.map(p => ({value: p.id, label: p.termCode}))}
                                    />
                                }
                            />
                            {errors.clientIncoTerms &&
                                <ValidationError error={errors.clientIncoTerms[0].incoTermId}/>
                            }
                        </Grid>
                        {}
                        <Grid item xs={1.3} container direction="row" alignItems="flex-end">
                             <Controller  
                             control={control}
                             name="excludeDeliveryAddress"
                             defaultValue={isChecked}
                             render={({ value, onChange }) =>
                                 <div className="flex items-center justify-center space-x-2 mt-4">
                                      <input
                                         type="checkbox"
                                         checked={isChecked}
                                         onChange={(e) => {
                                         onChange(e.target.checked)
                                         handleCheckboxChange(e)       
                                         setData({...data, excludeDeliveryAddress: isChecked})
                                          }}
                                        disabled={disable}
                                      //  className="w-5 h-5"
                                      />
                                      
                                      <label htmlFor="myCheckbox" className="text-sm">Exclude delivery address</label>
                                     </div>
                                      }
                                    />                                
                        </Grid>
                        <Grid item xs={12}>

                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel label="Commodity Types"
                                              className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                              labelPlacement="top"
                                              control={<></>}/>
                            <Controller
                                name="commodityTypesSelection"
                                control={control}
                                label="Commodity Types"
                                color="primary"
                                variant="outlined"
                                defaultValue={data.commodityTypes.map(ct => ({
                                        value: ct.commodityTypeId,
                                        label: ct.commodityTypeName
                                    }
                                ))}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Select
                                        isMulti
                                        menuPlacement="auto"
                                        menuPosition="fixed"
                                        options={commodityTypeList}
                                        value={
                                            data.commodityTypes.map(ct => ({
                                                    value: ct.commodityTypeId,
                                                    label: ct.commodityTypeName
                                                }
                                            ))

                                        }
                                        onChange={val => {
                                            onChange(val.value);
                                            onCommodityTypeChanged(val);
                                        }}
                                        inputRef={ref}
                                    />)}
                            />
                        </Grid>
                        <Grid item xs={6}></Grid>
                        <Grid item xs={6}>
                            <FormControlLabel label="Override Country Defaults?" variant="outlined" control={
                                <Controller
                                    name="overrideCountryDefaults"
                                    control={control}
                                    fullWidth
                                    color="primary"
                                    defaultValue={data.overrideCountryDefaults}
                                    render={(
                                        {onChange, onBlur, value, name, ref},
                                        {invalid, isTouched, isDirty}
                                    ) => (
                                        <Checkbox
                                            onBlur={onBlur}
                                            onChange={(e) => {
                                                onChange(e.target.checked);
                                                setData({...data, overrideCountryDefaults: e.target.checked})
                                            }}
                                            checked={value}
                                            inputRef={ref}
                                        />
                                    )}
                                />
                            }/>
                        </Grid>
                        <Grid item xs={12}>
                            <CountryOverride/>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    )
        ;
};

export default GrantInfo;
